import { Loader } from 'components/ui'
import { LoaderContainer, LoaderText, LoaderWrap } from './Style'

export function SectionLoader() {
  return (
    <LoaderWrap>
      <LoaderContainer>
        <Loader size={8} />
        <LoaderText>
          Generated airdrop transactions
          <br /> Please wait
        </LoaderText>
      </LoaderContainer>
    </LoaderWrap>
  )
}
